import React from 'react';
import { Box, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import useTranslation from '../../customHooks/translations';

const PredictionTodayCard = ({ day, isLoading }) => {
  const translation = useTranslation();

  function activityLabel(pct) {
    if (pct >= 60) return translation.fishingPrediction.activityHigh;
    if (pct >= 30) return translation.fishingPrediction.activityMedium;
    return translation.fishingPrediction.activityLow;
  }

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
        <CircularProgress size={28} sx={{ color: DEFAULT_THEME_COLOR }} />
      </Box>
    );
  }

  if (!day) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 2 }}>
        {translation.fishingPrediction.noData}
      </Typography>
    );
  }

  const top5 = (day.species || []).slice(0, 5);

  return (
    <Card variant="outlined" sx={{ borderColor: DEFAULT_THEME_COLOR }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          {translation.fishingPrediction.todayForecast} — {day.date}
        </Typography>
        {top5.map(s => (
          <Box key={s.name} sx={{ mb: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
              <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>{s.name}</Typography>
              <Typography variant="body2" color="text.secondary">{activityLabel(Math.round(s.probability * 100))} {Math.round(s.probability * 100)}%</Typography>
            </Box>
            <Box sx={{ height: 6, borderRadius: 3, bgcolor: '#e0e0e0', overflow: 'hidden' }}>
              <Box sx={{
                height: '100%',
                width: `${s.probability * 100}%`,
                bgcolor: DEFAULT_THEME_COLOR,
                borderRadius: 3,
              }} />
            </Box>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

export default PredictionTodayCard;
